/* @flow */

import {useQuery} from '@apollo/react-hooks';
import {safelyGetGraphQLErrorMessage, makeDataSafe} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMarkets as GetMarketsQuery,
    GetMarkets_markets_edges_node as Market,
} from 'nutshell-graphql-types';

import GET_MARKETS from '../queries/get-markets.graphql';

export const useGetMarkets = (): {
    markets: Market[],
    isLoading: boolean,
    errorMessage: ?string,
} => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetMarketsQuery, {}>(GET_MARKETS, {
        fetchPolicy: 'cache-and-network',
    });

    const {markets: marketsConnection} = makeDataSafe(data);

    const markets =
        (marketsConnection &&
            marketsConnection.edges &&
            marketsConnection.edges.map((edge) => edge && edge.node)) ||
        [];

    return {
        markets,
        isLoading,
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
